import CustomButton from '@perpay-web/components/base/CustomButton/CustomButton';
import Modal from '@perpay-web/components/base/Modal/Modal';
import CardCta from '@perpay-web/fintech/components/base/CardCta/CardCta';

import styles from './EmployerInfoModal.scss';

type ProductType = 'marketplace' | 'card' | 'perpayPlusSolo';

type ProductDisplayOption = {
    title: string;
    mode: 'primary' | 'dark';
};

const productDisplayOptions: {
    [key in ProductType]: ProductDisplayOption;
} = {
    marketplace: { title: 'Perpay', mode: 'primary' },
    card: { title: 'The Perpay Credit Card', mode: 'dark' },
    perpayPlusSolo: { title: 'Perpay+', mode: 'primary' },
};

type EmployerInfoModalProps = {
    onSubmit: VoidFunction;
    onClose: VoidFunction;
    product?: ProductType;
};

const EmployerInfoModal = ({
    onSubmit,
    onClose,
    product = 'card',
}: EmployerInfoModalProps) => (
    <Modal
        showClose
        className={styles.modal}
        onClose={onClose}
        containerClassName={styles['modal-container']}
    >
        <div className={styles.title}>Why do we ask for your employer?</div>
        <div className={styles['modal-copy']}>
            {productDisplayOptions[product].title} works seamlessly with your
            paycheck. Knowing your employer helps to simplify your payroll
            connection experience later on!
        </div>

        <div className={styles['modal-copy']}>
            Your information is always kept safe and secure and we will never
            contact your employer.
        </div>

        <div>
            <CardCta
                Component={CustomButton}
                className={styles['discard-button']}
                mode={productDisplayOptions[product].mode}
                onClick={onSubmit}
                type='button'
            >
                Got it!
            </CardCta>
        </div>
    </Modal>
);

export default EmployerInfoModal;
